/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 27.04.2016.
 */
import NavigationMenu from './navigation-menu';

export default NavigationMenu;



// WEBPACK FOOTER //
// ./src/containers/NavigationMenu/index.js